import Image1 from '../../../assets/images/s5_image_1.png'
import Image2 from '../../../assets/images/s5_image_2.png'
import BoxGradient from '../../../assets/images/s5_box_gradient.png'
import Daun1 from '../../../assets/images/s5_daun_1.png'
import Daun2 from '../../../assets/images/s5_daun_2.png'

const Section5 = () => {
    return (
        <div id='visi' className="w-full h-screen flex flex-col md:flex-row overflow-hidden">
            <div className="w-full md:w-1/2 h-full flex flex-col items-start justify-center px-5 md:px-0 md:pb-24  md:pl-10 gap-3 relative mt-16 md:mt-36">
                <img src={Daun1} alt="Kebun Jitu" className="max-w-[100px] md:max-w-[120px] object-contain z-10 absolute -top-10 md:top-0 right-0" loading='lazy' />
                <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Visi Kami</h1>
                <p className="text-justify  md:pr-10">
                    Visi kami merevolusi hortikultura lokal dengan menyediakan alat analisis tanah instan dan portabel yang memberdayakan petani melalui wawasan akurat berbasis data. Inovasi ini bertujuan untuk mengoptimalkan pengelolaan tanah, memungkinkan petani untuk membudidayakan tanaman mereka secara lebih efektif dan berkelanjutan, sehingga meningkatkan produktivitas dan berkontribusi pada pertumbuhan pertanian lokal.
                </p>
                <img src={Daun2} alt="Kebun Jitu" className="max-w-[200px] md:max-w-[250px] mx-auto md:mx-0 object-contain z-10 md:self-end" loading='lazy' />
            </div>
            <div className="w-full md:w-[60%] flex items-center justify-center relative gap-3  pr-5 md:pr-10 pt-10" loading='lazy'>
                <img src={Image1} alt="Kebun Jitu" className="max-w-[200px] object-contain z-10 mt-16" loading='lazy' />
                <img src={Image2} alt="Kebun Jitu" className="max-w-[200px] object-contain z-10 -mt-16" loading='lazy' />
                <img src={BoxGradient} alt="Kebun Jitu" className="max-w-[400px] object-contain absolute right-0 bottom-0 z-0" loading='lazy' />
            </div>
        </div>
    )
}

export default Section5